"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _works = require("@/api/works/works");
var _project = require("@/api/project/project");
var _expert = require("@/api/expert/expert");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      matchId: this.$route.query.matchId,
      noAssignTotal: 1,
      noAssignPage: {
        pageNum: 1,
        pageSize: 10
      },
      noAssignModelData: {
        name: ""
      },
      noAssignQueryGroup: [{
        label: "精确查找",
        type: "input",
        model: "name",
        placeholder: "姓名"
      }],
      noAssignTableData: [],
      defaultColumn2: [{
        name: "姓名",
        prop: "name",
        isShow: true,
        width: "100"
      }, {
        name: "登录账号",
        prop: "loginName",
        isShow: true,
        width: "150"
      }, {
        name: "所属学校",
        prop: "schoolName",
        isShow: true,
        width: "150"
      }],
      formatters2: {},
      minWidth: 200,
      multipleSelection: [],
      tableData: [],
      defaultColumn: [{
        name: "项目名称",
        prop: "matchName",
        isShow: true,
        width: "100"
      }, {
        name: "项目组别",
        prop: "groupName",
        isShow: true,
        width: "100"
      }, {
        name: "项目阶段",
        prop: "stageName",
        isShow: true,
        width: "100"
      }, {
        name: "学校名称",
        prop: "schoolName",
        isShow: true,
        width: "100"
      }, {
        name: "作品 / 课程名称",
        prop: "workName",
        isShow: true,
        width: "100"
      }, {
        name: "姓名",
        prop: "userName",
        isShow: true,
        width: "100"
      }, {
        name: "状态",
        prop: "status",
        isShow: true,
        width: "100",
        isFormats: true
      }, {
        name: "分数",
        prop: "score",
        isShow: true,
        width: "100"
      }],
      options: [{
        name: "分配",
        class: "editor",
        option: "allot",
        span: 24,
        isFuntion: true,
        optionFun: "cszpPd"
      }, {
        name: "评分详情",
        class: "editor",
        option: "comment",
        span: 24
      }, {
        name: "审核",
        class: "editor",
        option: "audit",
        span: 24,
        field: {
          name: "status",
          value: 1
        }
      }, {
        name: "退回",
        class: "editor",
        option: "unaudit",
        span: 24
      }, {
        name: "查看",
        class: "editor",
        option: "detail",
        span: 24
      }, {
        name: "删除",
        class: "delet",
        option: "deleteById",
        span: 24
      }],
      funBtns: [{
        size: "small",
        click: "assignExpert",
        icon: "",
        name: "一键分配专家",
        type: "primary"
      }, {
        size: "small",
        click: "sdfp",
        icon: "",
        name: "手动分配专家",
        type: "primary"
      }, {
        size: "small",
        click: "getScore",
        icon: "el-icon-s-fold",
        name: "导出成绩",
        type: "primary",
        loading: false
      }
      // {
      //   size: "small",
      //   click: "prize",
      //   icon: "",
      //   name: "设置奖项",
      //   type: "primary"
      // },
      // {
      //   size: "small",
      //   click: "unPublish",
      //   icon: "el-icon-document-delete",
      //   name: "取消发布",
      //   type: "danger"
      // },
      // {
      //   size: "small",
      //   click: "publish",
      //   icon: "el-icon-document-checked",
      //   name: "作品发布",
      //   type: "primary"
      // }
      ],
      formatters: {
        status: [
        // {
        //   name: "待审核",
        //   value: "1"
        // },
        // {
        //   name: "审核未通过",
        //   value: "2"
        // },
        {
          name: "待分配",
          value: "3"
        }, {
          name: "评审中",
          value: "4"
        }, {
          name: "结束",
          value: "5"
        }],
        isPublish: [{
          name: "未发布",
          value: "0"
        }, {
          name: "已发布",
          value: "1"
        }]
      },
      modelData: {
        groupId: "",
        stageId: "",
        userName: "",
        year: "",
        status: "",
        isPublish: ""
      },
      queryGroup: [{
        label: "所属组别",
        type: "select",
        model: "groupId",
        options: [],
        placeholder: "所属组别",
        change: "matchChangegroup"
      }, {
        label: "所属阶段",
        type: "select",
        model: "stageId",
        options: [],
        placeholder: "所属阶段",
        change: "matchChangestage"
      }, {
        label: "姓名",
        type: "input",
        model: "userName",
        placeholder: "姓名"
      }, {
        label: "状态",
        type: "select",
        model: "status",
        options: [{
          name: "待审核",
          value: "1"
        }, {
          name: "审核未通过",
          value: "2"
        }, {
          name: "待分配",
          value: "3"
        }, {
          name: "评审中",
          value: "4"
        }, {
          name: "结束",
          value: "5"
        }],
        placeholder: "审核状态"
      },
      // {
      //   label: "发布状态",
      //   type: "select",
      //   model: "isPublish",
      //   options: [
      //     {
      //       name: "未发布",
      //       value: "0"
      //     },
      //     {
      //       name: "已发布",
      //       value: "1"
      //     }
      //   ],
      //   placeholder: "发布状态"
      // },
      {
        label: "年份",
        type: "select",
        model: "year",
        options: [],
        placeholder: "年份"
      }],
      cszpPd: function cszpPd(row, callback) {
        if (row.status == 3 || row.status == 4) {
          callback(true);
        } else {
          callback(false);
        }
      },
      checkBoxData: [],
      checkBoxData2: [],
      page: {
        pageNum: 1,
        pageSize: 10
      },
      total: null,
      //设置奖项弹框
      prizeDialogVisible: false,
      // 手动分配
      sdfpDia: false,
      prizeValue: "1",
      stageId: 10,
      worksIds: [],
      expertIds: [],
      queryValue: "",
      allCheckBoxs: []
    };
  },
  components: {
    ZhjyTable: _zhjyTable.default,
    FunBtn: _funBtn.default,
    ZhjyPagination: _zhjyPagination.default,
    ZhjySerach: _zhjySerach.default
  },
  created: function created() {
    // 获取作品列表
    this.list();
    //获取组别
    this.getGroupList();
    //获取阶段
    this.getStageList();
  },
  methods: {
    // 查看评语
    comment: function comment(i) {
      this.$router.push({
        path: "/entryDesignTest/comment",
        query: {
          id: i.id
        }
      });
    },
    unaudit: function unaudit(row) {
      var _this = this;
      this.$confirm("确认退回该作品？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _works.exitWorksStatus)({
          worksId: row.id
        }).then(function (res) {
          _this.$message.success(res.data);
          _this.list();
        });
      }).catch(function () {
        _this.$message.info("取消");
      });
    },
    // 删除操作
    deleteById: function deleteById(row) {
      var _this2 = this;
      var id = [];
      if (!row && this.checkBoxData.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        id.push(row.id);
      } else if (this.checkBoxData.length > 0) {
        id = this.checkBoxData;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _expert.delWorks)({
          idList: id,
          matchId: _this2.$route.query.matchId
        }).then(function () {
          _this2.$message.success("操作成功。");
          _this2.list();
        });
      }).catch(function () {
        _this2.$message.info("取消删除。");
      });
    },
    // 分配按钮
    allot: function allot(e) {
      this.$router.push({
        path: "/entryDesignTest/allocation",
        query: {
          stageId: e.stageId,
          worksId: e.id
        }
      });
    },
    // 精确查找
    noAssignSearch: function noAssignSearch(val) {
      console.log("val", val);
      this.queryValue = val.name;
      this.getSdfpList();
    },
    noAssignHandleSizeChange: function noAssignHandleSizeChange(val) {
      this.noAssignPage.pageSize = val;
      this.getSdfpList();
    },
    noAssignHandleCurrentChange: function noAssignHandleCurrentChange(val) {
      this.noAssignPage.pageNum = val;
      this.getSdfpList();
    },
    noAssignHandleSelectionChange: function noAssignHandleSelectionChange(val) {
      var _this3 = this;
      this.expertIds = [];
      val.forEach(function (item) {
        _this3.expertIds.push(item.userId);
      });
    },
    // 确认分配操作
    IsSdfp: function IsSdfp() {
      var _this4 = this;
      (0, _expert.stageExpertAdd)({
        expertIds: this.expertIds,
        stageId: this.stageId,
        worksIds: this.worksIds
      }).then(function (res) {
        if (res.code === 2000) {
          _this4.$message.success("操作成功。");
          _this4.sdfpDia = false;
          _this4.list();
        }
      });
    },
    // 手动分配专家按钮逻辑
    sdfp: function sdfp() {
      var v = this.checkBoxData2.length;
      if (v == 0) {
        this.$message.error("请先选择待分配状态数据，再进行分配。");
      } else if (v >= 1) {
        var flag = this.checkBoxData2[0].stageName;
        var x = this.checkBoxData2.every(function (item) {
          return flag === item.stageName;
        });
        if (x) {
          this.stageId = this.checkBoxData2[0].stageId;
          this.getSdfpList();
          this.sdfpDia = true;
        } else {
          this.$message.error("请选择相同项目阶段，进行分配。");
        }
      }
    },
    // 获取手动专家分配的列表
    getSdfpList: function getSdfpList() {
      var _this5 = this;
      (0, _expert.stageExpertList)({
        name: this.queryValue,
        pageNum: this.noAssignPage.pageNum,
        pageSize: this.noAssignPage.pageSize,
        stageId: this.stageId
      }).then(function (res) {
        var data = res.data;
        _this5.noAssignTableData = data.list;
        _this5.noAssignTotal = data.total;
      });
    },
    // 一键分配专家
    assignExpert: function assignExpert() {
      var _this6 = this;
      (0, _expert.aKeyMatchExpert)({
        matchId: this.$route.query.matchId
      }).then(function (res) {
        if (res.code === 2000) {
          _this6.$message.success(res.data.successMsg);
          _this6.list();
        }
      });
    },
    // 更换作品状态
    publish: function publish(e) {
      var _this7 = this;
      if (this.allCheckBoxs.length > 0) {
        (0, _expert.worksIsIssue)({
          ids: this.allCheckBoxs,
          status: e
        }).then(function (res) {
          if (res.code === 2000) {
            _this7.$message.success("操作成功。");
            _this7.list();
          }
        });
      } else {
        this.$message.error("请先勾选数据。");
      }
    },
    // 导出成绩
    getScore: function getScore() {
      var _this8 = this;
      this.funBtns[2].loading = true;
      (0, _expert.getScore)(_objectSpread({
        matchId: this.matchId,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize
      }, this.modelData)).then(function (res) {
        _this8.funBtns[2].loading = false;
        _this8.commonJs.download(res, "成绩.xlsx");
      });
    },
    load: function load() {},
    getGroupList: function getGroupList() {
      var _this9 = this;
      (0, _project.matchGroupListAll)({
        id: this.matchId
      }).then(function (res) {
        _this9.queryGroup[0].options = [];
        for (var k in res.data.list) {
          _this9.queryGroup[0].options.push({
            name: res.data.list[k].groupName,
            value: res.data.list[k].id
          });
        }
      });
    },
    getStageList: function getStageList() {
      var _this0 = this;
      (0, _project.stageList)({
        matchId: this.matchId
      }).then(function (res) {
        _this0.queryGroup[1].options = [];
        for (var k in res.data) {
          _this0.queryGroup[1].options.push({
            name: res.data[k].stageName,
            value: res.data[k].id
          });
        }
      });
    },
    list: function list() {
      var _this1 = this;
      (0, _works.getWorksList)(_objectSpread(_objectSpread({
        matchId: this.matchId
      }, this.page), this.modelData)).then(function (res) {
        _this1.tableData = res.data.list;
        _this1.total = res.data.total;
      });
    },
    prize: function prize() {
      if (this.checkBoxData.length == 0) {
        this.$message.warning("请选择！");
        return false;
      }
      this.prizeDialogVisible = true;
    },
    submitPrize: function submitPrize() {
      var _this10 = this;
      (0, _works.setPrize)({
        status: this.prizeValue,
        ids: this.checkBoxData
      }).then(function (res) {
        if (res.code == 2000) {
          _this10.$message.success(res.msg);
          _this10.prizeDialogVisible = false;
          _this10.list();
        } else {
          _this10.$message.error(res.msg);
        }
        return false;
      });
    },
    matchdaochu: function matchdaochu() {
      var _this11 = this;
      if (this.checkBoxData.length == 0) {
        this.$message.warning("请选择！");
        return false;
      }
      (0, _works.downFilesByWorkIds)({
        idList: this.checkBoxData
      }).then(function (res) {
        console.log("data", res);
        _this11.download(res.data, "结果.xlsx");
      });
    },
    download: function download(data, name) {
      var blob = new Blob([data], {
        type: "application/vnd.ms-excel"
      });
      var fileName = name;
      if ("download" in document.createElement("a")) {
        // 非IE下载
        var elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      } else {
        // IE10+下载
        navigator.msSaveBlob(blob, fileName);
      }
    },
    audit: function audit() {},
    detail: function detail(row) {
      this.$router.push({
        path: "/entryDesignTest/view",
        query: {
          worksId: row.id
        }
      });
    },
    search: function search() {},
    handleSelectionChange: function handleSelectionChange(val) {
      var _this12 = this;
      //作品状态为3，待分配状态
      this.allCheckBoxs = [];
      this.checkBoxData = [];
      this.checkBoxData2 = [];
      this.worksIds = [];
      val.forEach(function (item) {
        _this12.allCheckBoxs.push(item.id);
        if (item.status == 3) {
          _this12.checkBoxData.push(item.id);
          _this12.checkBoxData2.push({
            stageId: item.stageId,
            stageName: item.stageName
          });
          _this12.worksIds.push(item.id);
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNum = e;
      this.list();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNum = 1;
      this.list();
    }
  }
};